import { render, staticRenderFns } from "./ApprovalPlanSales.vue?vue&type=template&id=2caceeda"
import script from "./ApprovalPlanSales.vue?vue&type=script&lang=js"
export * from "./ApprovalPlanSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports